import script from "./TaskCreationView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCreationView.vue?vue&type=script&setup=true&lang=js"

import "./TaskCreationView.vue?vue&type=style&index=0&id=6814ce0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6814ce0c"]])

export default __exports__